const { types } = require('@showrunner/codex')
const { templates } = require('./templates')
const substituteEncodedCharacters = require('./substituteEncodedCharacters')
const substituteEncodedCarets = require('./substituteEncodedCarets')

function proseParser (content, mode) {
  // look out for malformed/empty blocks { "type": "action" }
  if (!mode || !content || content.length < 1) return

  const template = templates[mode]
  let s = ''

  content.forEach((snippet) => {
    snippet.text = substituteEncodedCarets(snippet.text)

    // link, comment and other unstyled marks in prose scripts should be ignored
    // turn the remaining marks into a string description of the decoration

    const style = snippet.marks && snippet.marks.map(mark => {
      if (mark.type === types.STRONG) return 'bold'
      if (mark.type === types.EM) return 'italic'
      if (mark.type === types.STRIKE) return 'strikeout'
      if (mark.type === types.UNDERLINE) return mark.type
      return null
    })
      .filter(x => x) // weed out unstyled 'link/comment' marks
      .sort() // alphabetize
      .join('_') // concatenate with underscores

    if (style) {
      // guard against blocks with no text that have marks applied
      // this is kinda WTF, but it works
      if (snippet.text) {
        s += snippet.text.replace(/([\s\S]*)/, template[style].replace('$2', '$1'))
      }

      // check for & and /t inside marked strings too
      s = substituteEncodedCharacters(s, mode)
    } else if (snippet.type === 'hard_break') {
      s += template.newline
    } else {
      s += snippet.text
      s = substituteEncodedCharacters(s, mode)
    }
  })
  return s
}

module.exports = proseParser
